
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { StringUtils } from '../../../com/ibm/tw/commons/utils/string.utils';
import { AxthenticationService } from './../../../services/axthentication.service';

@Component({
    standalone: false,
    templateUrl: 'paypal.component.html'
})

export class PaypalComponent implements OnInit {
    loading = false;

    constructor(protected router: Router,
        private activatedRoute: ActivatedRoute,
        protected axthenticationService: AxthenticationService
    ) {
        this.activatedRoute.queryParams.subscribe(params => {

            // GIB-4871 調整取得cache key欄位名稱
            let verificationCode = params['code'];
            console.log('>>>>>>> PaypalComponent verificationCode : ' + verificationCode);

            // 保留PayPalCallBack的資料
            localStorage.setItem('code', verificationCode);
            window.close();
        });
    }

    ngOnInit() {
        // console.log('PaypalComponent init...');
    }

}
